var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91667 2.08337V1.66671C1.91667 1.20647 2.28976 0.833374 2.75 0.833374H5.25C5.71024 0.833374 6.08333 1.20647 6.08333 1.66671V2.08337H7.33333C7.56345 2.08337 7.75 2.26992 7.75 2.50004C7.75 2.73016 7.56345 2.91671 7.33333 2.91671H6.91667V7.50004C6.91667 8.1904 6.35702 8.75004 5.66667 8.75004H2.33333C1.64298 8.75004 1.08333 8.1904 1.08333 7.50004V2.91671H0.666667C0.436548 2.91671 0.25 2.73016 0.25 2.50004C0.25 2.26992 0.436548 2.08337 0.666667 2.08337H1.91667ZM2.75 1.66671H5.25V2.08337H2.75V1.66671ZM1.91667 2.91671H6.08333V7.50004C6.08333 7.73016 5.89679 7.91671 5.66667 7.91671H2.33333C2.10322 7.91671 1.91667 7.73016 1.91667 7.50004V2.91671Z",
    fill: "#1A3D82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 3.75004H4.41667V7.08337H5.25V3.75004Z",
    fill: "#1A3D82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58333 3.75004H2.75V7.08337H3.58333V3.75004Z",
    fill: "#1A3D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash2);
export default __webpack_public_path__ + "static/media/trash2.79e306d89540dd1315c822006ffa9074.svg";
export { ForwardRef as ReactComponent };